<template>
	<div id="card">
		<div v-if='cardData.length != 0' class="card" v-for="(item,index) in cardData.list">
			<h3>{{item.bigtitle}}</h3>
			<p>{{item.smalltitle}}</p>
			<div class="list">
				<ul>
					<li>建议人群</li>
					<li>{{item.jy}}</li>
				</ul>
				
				<ul>
					<li>保障期</li>
					<li><center>{{item.time}}</center></li>
				</ul>
				<ul>
					<li>救援服务</li>
					<li>{{item.jyfw}}</li>
				</ul>
			</div>
			<div class="money">
				<p>
					<span>￥{{item.money}}元</span>
					<span>· 全国指导价</span>
				</p>
				<router-link :to="{path:'details',query:{index,tag:cardData.tag}}" >查看详情</router-link>
			</div>
		</div>
		<div v-if="cardData.length == 0" class="card cardNone">
			<img src="./img/none.png" alt="">
			<p>敬请期待</p>
		</div>
	</div>

</template>

<script>

	export default {
		props:[
			'cardData'
		]
	}
</script>

<style scoped="scoped">
	.card *{color: #333;}
	.card{background-color: white;padding: 30px 0;box-shadow: 0 0 20px rgba(63,180,253,0.2);border-radius: 5px;margin-bottom: 50px;}
	.card h3{font-size: 22px;text-align: center;}
	.card p{font-size: 18px;text-align: center;line-height: 60px;}
	.list{display: flex;justify-content: space-around;margin-top: 30px;}
	.list ul li{width: 180px;line-height: 30px;font-size: 18px;}
	.list ul li:first-child{text-align: center;color: #666;margin-bottom: 10px;}
	.money{position: relative;margin-top: 30px;}
	.money span:first-child{color: #fea100;font-size: 30px;}
	.money span{line-height: 60px;display: inline-block;vertical-align: middle;font-size: 16px;color: #666;}
	.money a{position: absolute;top: 20px;right: 200px;font-size: 16px;color: #00abfa;background: url(../../assets/img/more.png) center right no-repeat;padding-right: 20px;}
	.cardNone img{display: block;margin: 30px auto;}
	.cardNone p{color: #666;text-indent: 30px;}
</style>



// WEBPACK FOOTER //
// src/views/home/card.vue